import { createBasicSelector } from 'util/redux'
import { emptyObj } from 'util/objects'

import { selectBase } from './selectBase'

export const selectAiComposerRequest = createBasicSelector(
  selectBase,
  base => base.composerRequest || emptyObj
)
